<template>

  <div class="analytic">
    <div v-if="cekChart(3)" class="mt-4">
      <persentase-tren-sentiment-component :key="data_sentiment_key" :data="data_sentiment"
        :stats="data_sentiment_stats" />
    </div>


    <div class="row">
      <div v-if="display_tipe == 1 || display_tipe == 3" class="px-gap mb-4 h-100 col-md-4">
        <top-sources-component title="Media Sosial" sentimen="1" type="1" :is_disabled="true"/>
      </div>

      <div v-if="display_tipe == 1 || display_tipe == 3" class="px-gap mb-4 h-100 col-md-4">
        <top-sources-component title="Media Sosial" type="1" sentimen="0" :is_disabled="true" />
      </div>

      <div v-if="display_tipe == 1 || display_tipe == 3" class="px-gap mb-4 h-100 col-md-4">
        <top-sources-component title="Media Sosial" type="1" sentimen="-1" :is_disabled="true" />
      </div>
    </div>

    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>

</template>

<script>
import $ from "jquery";
import persentase_tren_sentiment from "@/views/components/analytics/account-integrity/persentase_tren_sentiment.vue";
import top_sources from "@/views/components/analytics/account-integrity/top_sources.vue";

export default {
  name: "tab_medsos_account_integrity",
  components: {
    "persentase-tren-sentiment-component": persentase_tren_sentiment,
    "top-sources-component": top_sources,
  },
  data() {
    return {
      tour_steps: [],

      data_sentiment: null,
      data_sentiment_stats: null,
      data_sentiment_key: 50,

      dt_head: [],
      dt_body: [],
      dt_config: {},

      id_project: this.$store.getters.user.id_project,
      added_charts: [],
      api_url: process.env.VUE_APP_API_URL,
      res: {},

      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,

      is_wordcloud_loading: true,
      is_wordcloud_hashtag: false,
    };
  },
  methods: {
    getData: function () {
      let self = this;
      var params = this.$route.query;
      if ("items" in params) {
        delete params.items;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");


      this.data_sentiment = null;
      this.data_sentiment_stats = null;
      this.data_sentiment_key++;


      if (query != "") {
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "analytics/" +
          this.id_project +
          "?" +
          query;
        this.$http
          .get(api)
          .then(function (response) {
            if (response.status == 200) {
              self.res = response.data;
              self.data_sentiment_stats = [
                {
                  name: "Positif",
                  y: response.data.stats.positif,
                  color: $("body").css("--success") + "AA",
                  source: [
                    'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
                  ]
                },
                {
                  name: "Netral",
                  y: response.data.stats.netral,
                  color: "#0e6d87AA",
                  source: [
                    'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
                  ]
                },
                {
                  name: "Negatif",
                  y: response.data.stats.negatif,
                  color: $("body").css("--danger") + "AA",
                  source: [
                    'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
                  ]
                },
              ];
              self.data_sentiment_stats["name"] = "Mention";
              if (self.added_charts.includes(3)) {
                self.assembleDataSentiment(response.data.trend_sentiment);
              }
            } else {
              self.data_sentiment = {};
              self.data_sentiment_stats = [];
              self.data_sentiment_stats["positif"] = 0;
              self.data_sentiment_stats["netral"] = 0;
              self.data_sentiment_stats["negatif"] = 0;
              self.data_sentiment_key++;
            }
          })
          .catch(function (err) {
            console.log(err);
          })
          .finally(() => {
            this.data_mention_per_topik_key++;
          });
      }
    },
    getTopikSource: function () {
      var params = this.$route.query;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query != "") {
        this.data_topic_source = null;
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "charts/bar/topic-source/" +
          this.id_project +
          "?tipe=medsos&" +
          query;
        this.$http.get(api).then((response) => {
          if (response.status == 200) {
            this.data_topic_source = response.data;
            this.data_topic_source.source = [
              'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
            ];
          } else {
            this.data_topic_source = {};
          }
        });
      }
    },
    assembleDataSentiment: function (dataset) {
      let data = {
        x: dataset.date,
        y: [
          {
            name: "Positif",
            data: dataset.positif,
            color: $("body").css("--success"),
          },
          {
            name: "Netral",
            data: dataset.netral,
            color: $("body").css("--info"),
            // visible: false,
          },
          {
            name: "Negatif",
            data: dataset.negatif,
            color: $("body").css("--danger"),
          },
        ],
        yName: "Total",
      };
      this.data_sentiment = data;
      this.data_sentiment.source = [
        'facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'forum'
      ];
      this.data_sentiment_key++;
    },
    initChartAnalytic: function () {
      let api = this.api_url + "project-detail/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.added_charts = response.data.project_detail.charts
              ? response.data.project_detail.charts
              : [];
          }
          this.getData();
          this.getTopikSource();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cekChart: function (id) {
      return this.added_charts.includes(id);
    },
  },
  watch: {
    $route() {
      var params = this.$route.query;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (this.query != query && query != "") {
        this.getData();
        this.getTopikSource();
      }
    },
  },
  created: function () {
    this.initChartAnalytic();
  },
  mounted: function () {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("body").offset().top,
      },
      1000
    );
    let v_step = [];
    v_step[0] = {
      target: "#page-header-validasi",
      header: {
        title: "Filter Validasi",
      },
      content: `Digunakan untuk memfilter data berdasarkan status validasi`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: ".card-body",
      header: {
        title: "Berpindah Tab",
      },
      content:
        "Anda dapat berpindah tab dengan melakukan klik pada media konvensional atau media sosial.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#mention-reach",
      header: {
        title: "Mention dan Reach",
      },
      content:
        "Menampilkan jumlah mention, jumlah reach, jumlah engagement, dan grafiknya pada media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#topik-by-source",
      header: {
        title: "Tren Topik Berdasarkan Source",
      },
      content:
        "Menampilkan grafik tren topik berdasarkan sumber dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#sources",
      header: {
        title: "Sources",
      },
      content:
        "Menampilkan sumber-sumber media sosial dengan jumlah mention untuk setiap sumbernya dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#tren-sources",
      header: {
        title: "Tren Mention",
      },
      content:
        "Menampilkan grafik tren mention dari setiap sumber pada media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#grafik-sentimen",
      header: {
        title: "Tren Sentimen",
      },
      content:
        "Menampilkan grafik dan persentase sentimen dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#daftar-topik",
      header: {
        title: "Daftar Topik",
      },
      content:
        "Menampilkan daftar topik dengan jumlah per sentimen dan total data dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#tren-topik",
      header: {
        title: "Tren Topik",
      },
      content:
        "Menampilkan grafik data tren berdasarkan topik dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[11] = {
      target: "#emotion",
      header: {
        title: "Emotion",
      },
      content:
        "Menampilkan persentase dan grafik tren emotion dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[12] = {
      target: "#hashtag",
      header: {
        title: "Hashtag",
      },
      content:
        "Menampilkan grafik dari jumlah hashtag untuk setiap mention dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[13] = {
      target: "#peak-time",
      header: {
        title: "Peak Time",
      },
      content:
        "Menampilkan grafik jumlah mention untuk setiap jam dan hari tertentu dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[14] = {
      target: "#wordcloud-container",
      header: {
        title: "Worcloud",
      },
      content:
        "Menampilkan kata kata yang terdapat pada mention dari media sosial dalam range waktu sesuai dengan filter tanggal. Kata yang ukurannya dicetak lebih besar merupakan kata yang memiliki jumlah penggunaan yang lebih banyak",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style>
.overlay-button {
  position: fixed;
  bottom: 45px;
  right: 30px;
  z-index: 9;
}

.overlay-button button {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  font-size: 30px;
  font-weight: bolder;
}

.nav-tabs-simple>li>a:after {
  background-color: #0f8ff9 !important;
}
</style>